/**
 * Secure Token Utilities
 * 
 * DEAD CODE: All callers (axiosInterceptor, useSessionMonitor) gate usage behind
 * REACT_APP_TOKEN_PREFLIGHT=true, which is not set. Token refresh is handled by
 * the axios response interceptor via authService instead.
 * 
 * Kept as a stub so existing imports don't break.
 */

export class SecureTokenUtils {
  static async validateToken(_token: string | null) {
    return { valid: false, error: 'Token preflight disabled' as string | undefined };
  }

  static async isTokenExpired(_token: string | null): Promise<boolean> {
    return true;
  }

  static getTokenExpirationTime(): Date | null {
    return null;
  }

  static isTokenExpiringSoon(): boolean {
    return true;
  }

  static async refreshToken(): Promise<string | null> {
    return null;
  }

  static async getCurrentValidToken(): Promise<string | null> {
    return null;
  }

  /** @deprecated */
  static parseJwt(_token: string) {
    return null;
  }
}

export default SecureTokenUtils;